<template>
  <div class="w-full bg-tethys-orange text-gray-900 text-center py-2 z-50">
    🚧 We are currently upgrading our management system. Some features may be temporarily unavailable. We apologize for the inconveniences. 🚧
  </div>
</template>

<style scoped>
/* .maintenance-banner {
  background: #ffcc00;
  color: #333;
  padding: 10px;
  text-align: center;
  font-weight: bold;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
} */
</style>